import { useEffect } from 'react'

import { HeaderShim } from '../fuselage/global/header/header'
import { PageHeader } from '../fuselage/theme/2023/blocks/page-header/page-header'

export default function Register () {


    useEffect( () => {
        (function(){var bz=document.createElement("script");bz.type="text/javascript";bz.async=true;bz.src="https://organizer.bizzabo.com/widgets/tickets/tickets.js";var s=document.getElementsByTagName("script")[0];s.parentNode.insertBefore(bz,s);})();
    }, [])

    return (
        <>
            <HeaderShim />

            <PageHeader>
                <p className="fs-1 fw-600">Register</p>
                <p>AviaDev Real Estate is included within the pass for the Africa Hospitality Investment Forum and AviaDev.</p>
                <p>Alternatively, you can purchase a ticket just for AviaDev Real Estate.</p>
            </PageHeader>

            <section className="block bg-default">

              

                <div className="container">
                    <div 
                        className="bizzabo-tickets-widget" 
                        data-event-id={`${process.env.BIZZABO_EVENT_ID}`} 
                        data-params="isInMinisite=true&widgetId=242912"
                    ></div>
                </div>
            </section> 
        </>
    )
}
